import { createFileRoute } from "@tanstack/react-router";
import { StrukturaFormPage } from "@/features/sys-premiowy/struktura-form-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/raporty/system-premiowy/struktura/nowa")({
	component: StrukturaFormPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.raporty.sys-premiowy-struktura",
			location.pathname,
		);
	},
});
